import { Injectable } from '@angular/core';
import { ActionReducerMap } from '@ngrx/store';
import { UI_REDUCER } from '@safarilaw-webapp/shared/redux';
import { AppDialogUiReduxObject } from './actions/dialog-actions';
import { ISharedState } from './state.interface';
import { SafariInjector } from '@safarilaw-webapp/shared/common-objects-models';

@Injectable({
  providedIn: 'root'
})
export class DialogReducerService extends SafariInjector {
  private _appDialogUiReduxObject: AppDialogUiReduxObject;
  constructor() {
    super();
    this._appDialogUiReduxObject = this.inject(AppDialogUiReduxObject);
  }
  get reducers() {
    const reducers: ActionReducerMap<ISharedState> = {
      dialogState: UI_REDUCER(this._appDialogUiReduxObject)
    };
    return reducers;
  }
}
